/**
 * Garajdaki araçlar. Model dosyaları static/models/car/<id>/ (tools/blender/vehicles.py).
 * Fizik ölçüleri hepsinde aynıdır; yalnız gövde görseli değişir. Adlarda marka yok.
 */
export default [
    { id: 'default', name: { tr: 'ARAZİ', en: 'OFF-ROAD' } }, // askeri arazi aracı biçimi (geniş, kutu gövde; logo yok)
    { id: 'superspor', name: { tr: 'SÜPER SPOR', en: 'SUPERSPORT' } },
    { id: 'retro', name: { tr: 'RETRO GELECEK', en: 'RETRO FUTURE' } },
    { id: 'klasik', name: { tr: 'KLASİK', en: 'CLASSIC' } }, // 1950'ler açık yarış roadster'ı biçimi (logo / numara yok)
    { id: 'sut', name: { tr: 'SÜT KAMYONU', en: 'MILK TRUCK' } }, // tankında TAIGA logosu
    { id: 'kuvet', name: { tr: 'KÜVET', en: 'BATHTUB' } } // tekerlekli küvet: köpük, pembe lastik ördek, duş başlığı anten
]
